var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata",style:({padding: _vm.paddingSize+ 'px 0'})},[_c('img',{attrs:{"src":_vm.src,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }